import React, { useEffect, useMemo, useState } from "react";
import { CustomDropdown } from "../SpotOrders/spotOrderUi";
import SoMobileFilters from "./SoMobileFilters";
import OrderMobileCardShell from "./OrderMobileCardShell";

const ORDER_DESKTOP_COL_COUNT = 8;

const FUTURES_FILTER_OPTIONS = [
  { value: "all", label: "All" },
  { value: "usdt_m", label: "USDT-M" },
  { value: "coin_m", label: "COIN-M" },
];

/** Replace with API rows; empty shows no-data state. */
/*
const COPY_TRADING_ROWS = [
  {
    id: 1,
    leadTrader: "CryptoKing2024",
    position: "Long",
    time: "2026-04-20 08:15:32",
    avgEntry: "$64,250.50",
    closeType: "Take Profit",
    size: "0.5 BTC",
    margin: "3,212.53",
    avgExitPrice: "$65,180.00",
    exitPnl: "+464.75",
  },
  {
    id: 2,
    leadTrader: "CryptoKing2024",
    position: "Long",
    time: "2026-04-19 16:42:10",
    avgEntry: "$63,980.00",
    closeType: "Take Profit",
    size: "0.25 BTC",
    margin: "1,598.50",
    avgExitPrice: "$64,520.00",
    exitPnl: "+135.00",
  },
  {
    id: 3,
    leadTrader: "CryptoKing2024",
    position: "Short",
    time: "2026-04-18 11:05:44",
    avgEntry: "$3,245.20",
    closeType: "Take Profit",
    size: "12 ETH",
    margin: "1,944.12",
    avgExitPrice: "$3,198.50",
    exitPnl: "+560.40",
  },
  {
    id: 4,
    leadTrader: "CryptoKing2024",
    position: "Long",
    time: "2026-04-17 09:22:01",
    avgEntry: "$598.40",
    closeType: "Take Profit",
    size: "40 BNB",
    margin: "2,392.00",
    avgExitPrice: "$612.10",
    exitPnl: "+548.00",
  },
];
*/
const COPY_TRADING_ROWS = [];

const CopyTrading = () => {
  const [futures, setFutures] = useState("all");
  const [openDropdown, setOpenDropdown] = useState(null);

  useEffect(() => {
    if (!openDropdown) return undefined;
    const onDocClick = (e) => {
      const t = e.target;
      if (!(t instanceof Element)) return;
      if (!t.closest("[data-so-dropdown]")) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener("click", onDocClick, true);
    return () => document.removeEventListener("click", onDocClick, true);
  }, [openDropdown]);

  useEffect(() => {
    if (!openDropdown) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") setOpenDropdown(null);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [openDropdown]);

  const filteredRows = useMemo(() => {
    if (!futures || futures === "all") return COPY_TRADING_ROWS;
    const sz = (r) => String(r.size || "").toUpperCase();
    // Demo heuristic: USDT‑M rows are BTC‑quoted sizes; COIN‑M rows are altcoin sizes.
    if (futures === "usdt_m") return COPY_TRADING_ROWS.filter((r) => sz(r).includes("BTC"));
    if (futures === "coin_m") return COPY_TRADING_ROWS.filter((r) => !sz(r).includes("BTC"));
    return COPY_TRADING_ROWS;
  }, [futures]);

  const resetFilters = () => setFutures("all");

  const renderToolbar = (stacked, keyPrefix) => {
    const pref = keyPrefix ? `${keyPrefix}-` : "";
    return (
    <div className={`so-toolbar ${stacked ? "so-toolbar--stack" : ""}`} role="search" aria-label="Filter copy trading">
      <div className="so-toolbar__left">
        <CustomDropdown
          id={`${pref}cpt-dd-futures`}
          label="Futures"
          value={futures}
          options={FUTURES_FILTER_OPTIONS}
          onChange={setFutures}
          menuKey={`${pref}cpt-futures`}
          openKey={openDropdown}
          onOpenToggle={setOpenDropdown}
        />
      </div>
    </div>
    );
  };

  const renderEmptyBody = () => (
    <tr>
      <td colSpan={8} className="so-table__emptyWrap">
        <div className="so-emptyState" role="status">
          <img src="/images/no-data.svg" alt="" width={120} height={144} className="so-emptyState__img" />
        </div>
      </td>
    </tr>
  );

  const PositionPill = ({ value }) => {
    if (value === "Long") return <span className="so-side--buy">{value}</span>;
    if (value === "Short") return <span className="so-side--sell">{value}</span>;
    return <span className="so-badge--closed">{value}</span>;
  };

  return (
    <div className="dashboard_right">
      <div className="dashboard_listing_section2 Overview_mid">
        <div className="listing_left_outer full_width transaction_history_t desktop_view2 so-desktopWrap">
          <main className="so-page" aria-labelledby="so-copy-trading-title">
            <h1 id="so-copy-trading-title" className="so-page__title">
              Copy Trading
            </h1>

            {renderToolbar(false, "desk")}

            <div className="so-tableWrap so-tableWrap--staking so-tableWrap--copyTrading">
              <table className="so-table so-table--rowLines so-table--copyTrading">
                <thead>
                  <tr>
                    <th scope="col">Lead Trader</th>
                    <th scope="col">Position</th>
                    <th scope="col">Time</th>
                    <th scope="col">
                      Average Entry Price(USDT)
                    </th>
                    <th scope="col">Close Type</th>
                    <th scope="col">
                      Size
                    </th>
                    <th scope="col">
                      Margin(USDT)
                    </th>
                    <th scope="col">
                      Average Exit Price(USDT)
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredRows.length === 0
                    ? renderEmptyBody()
                    : filteredRows.map((r) => (
                        <tr key={r.id}>
                          <td>
                            <span className="so-contractCell__symbol">{r.leadTrader}</span>
                          </td>
                          <td>
                            <PositionPill value={r.position} />
                          </td>
                          <td className="so-num">{r.time}</td>
                          <td className="so-num">{r.avgEntry}</td>
                          <td>
                            <span className="so-pnl--profit">{r.closeType}</span>
                          </td>
                          <td className="so-num">{r.size}</td>
                          <td className="so-num">{r.margin}</td>
                          <td className="so-num">
                            <div className="so-copyExitCell">
                              <span>{r.avgExitPrice}</span>
                              <span className="so-pnl--profit">{r.exitPnl}</span>
                            </div>
                          </td>
                        </tr>
                      ))}
                </tbody>
              </table>
            </div>
          </main>
        </div>

        <div className="order_history_mobile_view so-mobile">
          <h2 className="so-mobile__title">Copy Trading</h2>
          <div className="so-mobile__toolbar">
            <SoMobileFilters
              modalId="mob-copytrading-filters"
              toolbar={renderToolbar(true, "mob")}
              onReset={resetFilters}
            />
          </div>
          {filteredRows.length === 0 ? (
            <div className="so-emptyState so-emptyState--mobile" role="status">
              <img src="/images/no-data.svg" alt="" width={120} height={144} className="so-emptyState__img" />
            </div>
          ) : (
            filteredRows.map((r) => (
              <OrderMobileCardShell key={`m-${r.id}`} desktopColumnCount={ORDER_DESKTOP_COL_COUNT} popupTitle="Copy trading details">
                <div className="so-mobileCard__row">
                  <span>Lead Trader</span>
                  <span className="so-contractCell__symbol">{r.leadTrader}</span>
                </div>
                <div className="so-mobileCard__row">
                  <span>Position</span>
                  <PositionPill value={r.position} />
                </div>
                <div className="so-mobileCard__row">
                  <span>Time</span>
                  <span className="so-num">{r.time}</span>
                </div>
                <div className="so-mobileCard__row">
                  <span>Average Entry Price(USDT)</span>
                  <span className="so-num">{r.avgEntry}</span>
                </div>
                <div className="so-mobileCard__row">
                  <span>Close Type</span>
                  <span className="so-pnl--profit">{r.closeType}</span>
                </div>
                <div className="so-mobileCard__row">
                  <span>Size</span>
                  <span className="so-num">{r.size}</span>
                </div>
                <div className="so-mobileCard__row">
                  <span>Margin(USDT)</span>
                  <span className="so-num">{r.margin}</span>
                </div>
                <div className="so-mobileCard__row">
                  <span>Average Exit Price(USDT)</span>
                  <span className="so-mobileCard__stack">
                    <span className="so-num">{r.avgExitPrice}</span>
                    <span className="so-pnl--profit">{r.exitPnl}</span>
                  </span>
                </div>
              </OrderMobileCardShell>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default CopyTrading;
